export default __webpack_public_path__ + "static/image-7-00d565a1ee2bf6d31ee24d0310404131.jpg";